import { Box, Button } from '@mui/material'
// eslint-disable-next-line no-restricted-imports
import { Link, RouteObject } from 'react-router'
import * as React from 'react'

type LinkedRoute = RouteObject & {
  key?: string
  title: string
  description: string
}

export const PlainLink = Link

export function RouteLink({
  route,
  disabled,
}: {
  route: LinkedRoute
  disabled?: boolean
}) {
  return (
    <Box key={route.key} padding="5px">
      <Button
        disabled={disabled}
        to={{
          pathname: route.path,
        }}
        component={Link}
      >
        {route.title}
      </Button>
      <Box paddingLeft="15px" color="darkGrey">
        {route.description}
      </Box>
    </Box>
  )
}
